<template>
  <edit-meeting />
</template>

<script>
import EditMeeting from "@/components/3pl/CRM/Meetings/MeetingForm";
export default {
  components: {
    EditMeeting,
  },
};
</script>

<style></style>
